export default __webpack_public_path__ + "static/media/dots2.db1c3d8f.png";